//Converts a string to the proper format to be displayed in a 
//HTML date field.

export default function DateConversion(date: Date | undefined) {

  const options={month: '2-digit', day: '2-digit', year: 'numeric'}
  return (date)?.toLocaleDateString("en-US", options) || ""
}